import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { IceBreakerKind, IceBreakerModel } from '../model/IceBreakerModel';

export class IceBreakerController extends AuthenticatedController {
  static getAll(botId: number, platform: IceBreakerKind, token?: string) {
    if (token) {
      return super.get(APIRoutes.STANDALONE_BOT_ICE_BREAKER({ token }));
    }
    return super.get(APIRoutes.ICE_BREAKERS(botId, platform));
  }

  static putIceBreaker(botId: number, entity: Partial<IceBreakerModel>) {
    return super.put(APIRoutes.ICE_BREAKER(botId, entity.id as number), entity);
  }
}
